import React, { SVGProps } from "react";

export default function SupCheck(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15.3535 6.67683L14.6464 5.96973L7.99998 12.6162L5.35353 9.96973L4.64642 10.6768L7.99998 14.0304L15.3535 6.67683Z" fill="currentColor" />
    </svg>
  );
}
